/**
 * Product spec for browser tab titles (`document.title`).
 * CMS view configs supply `state.label` and drawer suffix strings; the UI appends
 * {@link BROWSER_TAB_TITLE_SUFFIX} when syncing titles to the browser tab.
 */
export const BROWSER_TAB_TITLE_SUFFIX = ' - Helo'

/** CMS `ViewConfig.state.label` values for list and detail pages. */
export const browserTabPageLabels = {
  home: 'Home',
  items: 'Items',
  orders: 'Orders',
  shipments: 'Shipments',
  containers: 'Containers',
  fclContainers: 'FCL Containers',
  containerOrderItems: 'Container Order Items',
  item: 'Item',
  order: 'Order',
  shipment: 'Shipment',
  container: 'Container',
  portToPort: 'Port to Port',
} as const

/** Non-CMS pages set through static routes or `SetDocumentTitle`. */
export const browserTabStaticPageTitles = {
  savedViews: 'Saved Views',
  settings: 'Settings',
  userGuide: 'User Guide',
  signIn: 'Sign In',
} as const

/** Drawer tab segments (`browserTabTitleSuffixWhenExpanded` on DrawerCard widgets). */
export const browserTabDrawerSuffixes = {
  details: 'Details',
  milestones: 'Milestones',
  supplemental: 'Supplemental',
} as const

export type BrowserTabTitleDrawerSuffix =
  (typeof browserTabDrawerSuffixes)[keyof typeof browserTabDrawerSuffixes]
